import { render, staticRenderFns } from "./AttributeAddValues.vue?vue&type=template&id=590e4e6d&"
import script from "./AttributeAddValues.vue?vue&type=script&lang=js&"
export * from "./AttributeAddValues.vue?vue&type=script&lang=js&"
import style0 from "./AttributeAddValues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports